import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=76f2fcb6&scoped=true&"
import script from "./BaseTabs.vue?vue&type=script&lang=ts&"
export * from "./BaseTabs.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&id=76f2fcb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f2fcb6",
  null
  
)

export default component.exports